import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EFPicture from '@elem/ui/ef-picture';

const FormMeets = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');

    return (
        <div className={`${styles.formMeets} GtmModuleData-section`} data-section-id={styles.formMeets} data-section-title={t(`form_meets_title`)}>
            <EFPicture
                src={'https://websiteoss.ecoflow.com/upload/image/1751270936514/FormMeets-pc.jpg'}
                srcPad="https://websiteoss.ecoflow.com/upload/image/1751270936683/FormMeets-h5.jpg"
                alt={t('form_meets_title')}
                className="banner"
            />
            <div className="text-container">
                <h2>
                    {t.rich(`form_meets_title`, {
                        sup: (text: string) => <sup>{text}</sup>,
                    })}
                </h2>
                <p>{t(`form_meets_sub_title`)}</p>
            </div>
        </div>
    );
};

export default FormMeets;
